<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M6.222 13.957C3.555 13.653 2 11.803 2 10v-.5A1.5 1.5 0 0 1 3.5 8h2.1a5.5 5.5 0 0 0-.393 1H3.5a.5.5 0 0 0-.5.5v.5c0 1.128.882 2.333 2.502 2.8c.192.416.435.804.72 1.157m3.404-8.888a2.75 2.75 0 1 0-3.299 1.848a5.5 5.5 0 0 1 1.078-.964Q7.209 5.999 7 6a1.75 1.75 0 1 1 1.241-.516a5.5 5.5 0 0 1 1.385-.415M6.635 9.92a2 2 0 0 0 1.43-2.478l-.156-.557q.383-.293.822-.497l.337.358a2 2 0 0 0 2.91.001l.325-.344q.447.212.834.518l-.126.423a2 2 0 0 0 1.456 2.519l.35.082a4.7 4.7 0 0 1 .01 1.017l-.461.118a2 2 0 0 0-1.43 2.477l.155.557q-.383.294-.822.498l-.337-.358a2 2 0 0 0-2.91-.002l-.324.344a4.3 4.3 0 0 1-.835-.518l.126-.422a2 2 0 0 0-1.456-2.52l-.35-.082a4.7 4.7 0 0 1-.01-1.016zm4.865.58a1 1 0 1 0-2 0a1 1 0 0 0 2 0"
    />
  </svg>
</template>

<script>
export default {
  name: 'UserManagementIcon',
};
</script>
